import Vue                            from 'vue'
import VueRouter                      from 'vue-router'

import TACHES_GTC                     from '../views/GTC/Taches.vue'
import GTC_RUNING_NODES                     from '../views/GTC/Runing_Nodes.vue'

import ENCOURS                        from '../views/ENCOURS.vue'
import MANOLO                         from '../views/MANOLO.vue'

import NEONARVAL                      from '../views/NEO_NARVAL/NEO-NARVAL.vue'
import NEO_ACQ_FILES                  from '../views/NEO_NARVAL/ACQ_Files.vue'
import NEONARVALNUIT                  from '../views/NEO_NARVAL/Nuit.vue'
import NEONARVALOBSERVATIONS          from '../views/NEO_NARVAL/Observations.vue'

import DRS                            from '../views/DRS/DRS.vue'

import SPIP                           from '../views/SPIP/SPIP.vue'

import Pilote                         from '../views/PILOTE/Pilote.vue'
import Pointing                       from '../views/PILOTE/Pointing.vue'



import JOURNALISATION                 from '../views/JOURNALISATION/JOURNALISATION.vue'

import JOURNALISATION_OBJETS          from '../views/JOURNALISATION/objets.vue'
import JOURNALISATION_DATES           from '../views/JOURNALISATION/dates.vue'


import DIAGNOSTIQUE_CRITICITE         from '../views/Diagnostique/Criticite.vue'

import DMP_NEONARVAL                  from '../views/Data/DMP_NEONARVAL.vue'
import DMP_NARVAL                     from '../views/Data/DMP_NARVAL.vue'
import DMP_SPIP                       from '../views/Data/DMP_SPIP.vue'
import DATA_VOLUMES                   from '../views/Data/Volumes.vue'
import DATA_VOLUMES_EDIT              from '../views/Data/Volumes_edit.vue'



import Skyprobe_Datas                 from '../views/SKYPROBE/Skyprobe_Datas.vue'
import Skyprobe_Stats                 from '../views/SKYPROBE/Skyprobe_Stats.vue'
import Skyprobe_par_Objet             from '../views/SKYPROBE/Skyprobe_Par_Objet.vue'
import Skyprobe_par_Nuit              from '../views/SKYPROBE/Skyprobe_Par_Nuit.vue'
import Skyprobe_Live                  from '../views/SKYPROBE/Skyprobe_Live.vue'

import ETC                            from '../views/ETCs/ETC.vue'
import ETC_NEONARVAL                  from '../views/ETCs/ETC_NEONARVAL.vue'
import ETC_SPIP                       from '../views/ETCs/ETC_SPIP.vue'
import ETC_VISION                     from '../views/ETCs/ETC_VISION.vue'

Vue.use(VueRouter)

const routes = [



  {
    path: '/ETC',
    name: 'ETC',
    component: Skyprobe_Live
  },
  {
    path: '/ETC/NEONARVAL',
    name: 'ETC_NEONARVAL',
    component: ETC_NEONARVAL
  },
  {
    path: '/ETC/SPIP',
    name: 'ETC_SPIP',
    component: ETC_SPIP
  },
  {
    path: '/ETC/VISION',
    name: 'ETC_VISION',
    component: ETC_VISION
  },
  {
    path: '/',
    name: 'ETC_VISION',
    component: ETC_VISION
  },
  {
    path: '/Stats',
    name: 'Skyprobe_Stats',
    component: Skyprobe_Stats
  },

  {
    path: '/Objet',
    name: 'SKYPROBE_par_Objet',
    component: Skyprobe_par_Objet
  }, 
  {
    path: '/Nuit',
    name: 'SKYPROBE_par_Nuit',
    component: Skyprobe_par_Nuit
  },
  {
    path: '/Stats',
    name: 'Skyprobe_Statistiques',
    component: Skyprobe_Stats
  },
  



  {
    path: '/Datas',
    name: 'Skyprobe_Datas',
    component: Skyprobe_Datas
  },



  



      {
    path: '/GTC',
    name:  'GTC_RUNING_NODES',
    component: GTC_RUNING_NODES
  },
    {
    path: '/GTC/NODES',
    name:  'GTC_RUNING_NODES',
    component: GTC_RUNING_NODES
  },
  {
    path: '/GTC/TACHES',
    name:  'TACHES_GTC',
    component: TACHES_GTC
  },

  
  {
    path: '/JOURNALISATION/DATES',
    name:  'JOURNALISATION_DATES',
    component: JOURNALISATION_DATES
  },
  {
    path: '/JOURNALISATION/OBJETS',
    name:  'JOURNALISATION_OBJETS',
    component: JOURNALISATION_OBJETS
  },
  {
    path: '/JOURNALISATION',
    name:  'JOURNALISATION',
    component: JOURNALISATION
  },
  {
    path: '/MANOLO',
    name:  'MANOLO',
    component: MANOLO
  },


  {
    path: '/NEO-NARVAL',
    name: 'NEO-NARVAL',
    component: NEONARVAL
  },
  {
    path: '/DRS',
    name: 'DRS',
    component: DRS
  },
  {
    path: '/NEO_NARVAL/ACQ_FILES',
    name: 'NEO_ACQ_FILES',
    component: NEO_ACQ_FILES
  },
  {
    path: '/NEO-NARVAL/NUIT',
    name: 'NEO_NUIT',
    component: NEONARVALNUIT
  },
  {
    path: '/NEO-NARVAL/OBSERVATIONS',
    name: 'NEO_NARVAL_OBSERVATIONS',
    component: NEONARVALOBSERVATIONS
  },


  

  {
    path: '/SPIP',
    name: 'SPIP',
    component: SPIP
  },


  {
    path: '/Pilote',
    name: 'Pilote',
    component: Pilote
  },

  {
    path: '/Pointing',
    name: 'Pointing',
    component: Pointing
  },

  {
    path: '/DIAGNOSTIQUE/CRITICITE',
    name:  'DIAGNOSTIQUE_CRITICITE',
    component: DIAGNOSTIQUE_CRITICITE
  },
  {
    path: '/DATA/DMP_NARVAL',
    name:  'DMP_NARVAL',
    component: DMP_NARVAL
  },
  {
    path: '/DATA/DMP_NEO-NARVAL',
    name:  'DMP_NEO-NARVAL',
    component: DMP_NEONARVAL
  },
  {
    path: '/DATA/DMP_SPIP',
    name:  'DMP_SPIP',
    component: DMP_SPIP
  },
  {
    path: '/DATA/VOLUMES',
    name:  'DATA_VOLUMES',
    component: DATA_VOLUMES
  },
  {
    path: '/DATA/VOLUMES_EDIT',
    name:  'DATA_VOLUMES_EDIT',
    component: DATA_VOLUMES_EDIT
  },
]

const router = new VueRouter({
  routes
})


export default router
